import { BackToTop } from 'components/common';
import { MySegmentsTable } from 'components/segments/MySegments';
import { Tooltip } from 'components/ui';
import { PAID_PLAN_TOOLTIP } from 'config.js';
import { Link, useLocation } from 'react-router-dom';
import { usePageTitle } from 'utils';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

export default function MySegments() {
  usePageTitle('My segments | Segments');
  const location = useLocation();

  const {
    storeSubscriptionPlan,
    subscriptionPlans,
  } = useStoreSubscriptionPlan();

  return (
    <div className="relative max-w-screen-xl px-5 mx-auto md:pl-segments-72px md:pr-20 py-11">
      <p className="font-bold leading-6">Segments</p>
      <h1 className="mt-4 font-bold leading-10 text-segments-44px">
        My segments
      </h1>
      <div className="flex items-end space-x-10">
        <p className="mt-6 text-base">
          View, favorite, create, and sync to your email marketing service for
          targeting. We have automatically created segments for you using
          business rules + advanced algorithms such as{' '}
          <a
            href="https://help.tresl.co/en/articles/4324699-recency-frequency-monetary-rfm"
            target="_blank"
            rel="noreferrer"
            className="font-bold border-b text-segments-link border-segments-link"
          >
            RFM
          </a>{' '}
          and{' '}
          <a
            href="http://help.tresl.co/en/articles/4324698-customer-lifetime-value-clv "
            target="_blank"
            rel="noreferrer"
            className="font-bold border-b text-segments-link border-segments-link"
          >
            CLV
          </a>
          .
        </p>
        <div>
          <Tooltip
            text={PAID_PLAN_TOOLTIP}
            disabled={storeSubscriptionPlan > subscriptionPlans.small_business}
          >
            <Link
              to={{
                pathname: '/customers/create',
                search: location.search,
              }}
              className={`flex w-full p-4 space-x-2 text-base font-bold text-white border focus:outline-none border-segments-accent-color-1 rounded-2xl bg-segments-accent-color-1 hover:bg-segments-dark whitespace-nowrap ${
                storeSubscriptionPlan < subscriptionPlans.small_business &&
                'pointer-events-none opacity-50'
              }`}
            >
              + Create new
            </Link>
          </Tooltip>
        </div>
      </div>

      <MySegmentsTable />

      <BackToTop />
    </div>
  );
}
